import React from 'react';
var FlechaVertical = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12.1814 15.167L17.0198 10.1087L12.1814 5.05033", stroke: "var(--icon-primary-dark)", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M3.46912 10.1089L16.8843 10.1089", stroke: "var(--icon-primary-dark)", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })));
};
FlechaVertical.defaultProps = {
    className: '',
};
export default FlechaVertical;
